import { Component, ChangeDetectionStrategy, inject, computed, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import * as selectors from '../../store/selectors/content-pages.selector';

import { ResizeHtmlImagesPipe } from '@teamfoster/sdk/image';
import { StripEmbedPipe, getCookiePreferences } from '@teamfoster/sdk/cookie-ngrx';

import { DynamicHooksModule } from 'ngx-dynamic-hooks';
import { ContentAccordeonComponent } from 'src/app/standalone/components/content-accordeon/content-accordeon.component';
import { HeaderContentPageComponent } from 'src/app/standalone/components/header-content-page/header-content-page.component';
import { Header } from 'src/app/standalone/models/header.model';

@Component({
    selector: 'app-content-page',
    templateUrl: './content-page.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./content-page.component.scss'],
    imports: [
        ResizeHtmlImagesPipe,
        StripEmbedPipe,
        DynamicHooksModule,
        HeaderContentPageComponent,
    ]
})
export class ContentPageComponent {
  private store = inject(Store);
  page$ = this.store.selectSignal(selectors.getSelectedContentPage);
  cookiePreferences = this.store.selectSignal(getCookiePreferences);

  header: Signal<Partial<Header> | null> = computed(() => {
    const page = this.page$();
    if (page) {
      return {
        title: page.title,
        image: page.image,
        intro: page.intro || '',
      };
    }
    return null;
  });
}
